import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce-right.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
//
// COMMON
//
export var undefinedIfEmptyObject = function undefinedIfEmptyObject(object) {
  return Object.keys(object).length > 0 ? object : undefined;
};
export var identity = function identity(context) {
  return context;
}; // assoc -- immutably associate a key-value pair to an object. Lodash's
// equivalent, assign, mutates the source object.

export var assoc = function assoc(key, value, obj) {
  var _Object$assign;

  return Object.assign({}, obj, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
}; // assocAll -- immutably associate a bunch of key-value pairs to an object.
// Uses Object.assign, which inherently mutates the object.

export var assocAll = function assocAll(pairs) {
  return function (obj) {
    return Object.assign(Object.assign({}, obj), pairs);
  };
}; // computeProp -- immutably assign a property to an object using a function of
// that object.
//
// Example:
// const data = { a: 1, b: 2, c: 3 }
// computeProp('z', getProp('a'), data) ---> { a: 1, b: 2, c: 3, z: 1 }

export var computeProp = function computeProp(key, fn) {
  return function (obj) {
    return assoc(key, fn(obj), obj);
  };
};
/**
 * Creates a functional pipeline operating from left to right. Returns a function
 * which feeds its input into the first function in the pipeline, then feeds that
 * function's output into the second function, and so on until it returns the last
 * function's output. For example, `pipe(f1, f2, f3)(x)` is equivalent to
 * `f3(f2(f1(x)))`.
 */

export var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (first) {
    return fns.reduce(function (last, fn) {
      return fn(last);
    }, first);
  };
};
/**
 * Creates a functional pipeline operating from right to left. Returns a function
 * which feeds its input into the last function in the pipeline, then feeds that
 * function's output into the next function, and so on until it returns the first
 * function's output. For example, `compose(f1, f2, f3)(x)` is equivalent to
 * `f1(f2(f3(x)))`.
 */

export var compose = function compose() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (first) {
    return fns.reduceRight(function (last, fn) {
      return fn(last);
    }, first);
  };
};
/**
 * Applies a function to a context if and only if the context is not falsy. This
 * can be useful when computing values dependent on long dot-chained expressions
 * that may be undefined. For example: `apply(x => 'hello, ' + x)(some.long.chained.expression)`
 * is equivalent to `some.long.chained.expression && ('hello, ' + some.long.chained.expression)`.
 */

export var apply = function apply(fn) {
  return function (context) {
    return context && fn(context);
  };
};
export var isFalsy = function isFalsy(fn) {
  return function (context) {
    return !fn(context);
  };
};
export var getCurrentDateString = function getCurrentDateString() {
  var dateToday = new Date();
  var dd = String(dateToday.getDate()).padStart(2, '0');
  var mm = String(dateToday.getMonth() + 1).padStart(2, '0'); //January is 0!

  var yyyy = dateToday.getFullYear();
  dateToday = mm + '/' + dd + '/' + yyyy;
  return dateToday;
};
/**
 * Returns the value of a property on a context, looked up by bracket notation.
 * getProp returns undefined if the context value is undefined. For example,
 * `getProp('foo')(undefined)` will not crash since it will check for a falsy
 * context value before attempting to access 'foo'.
 *
 * Note: we generally use `getPath` instead of `getProp`, even when the "path" is
 * one key in length.
 */

export var getProp = function getProp(key) {
  return apply(function (context) {
    return context[key];
  });
};
/**
 * Returns the value of a property "path" on a context, looked up by bracket notation.
 * Essentially a functional pipeline of getProp calls. For example,
 * `getPath('people', 0, 'name')(data)` is equivalent to
 * `data && data.people && data.people[0] && data.people[0].name`.
 */

export var getPath = function getPath() {
  for (var _len3 = arguments.length, keys = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    keys[_key3] = arguments[_key3];
  }

  return function (context) {
    return pipe.apply(void 0, keys.map(getProp))(context);
  };
}; // overrideProp -- set a new value to a property of an object using a function of
// the existing value.
//
// Example:
// const data = { a: 'ace', b: 'BEEHIVE', c: 'chandelier' }
// overrideProp(
//   'b',
//   value => value.toLowerCase(),
//   data,
// ) ---> { a: 'ace', b: 'beehive', c: 'chandelier' }

export var overrideProp = function overrideProp(key, fn) {
  return function (obj) {
    return obj && assoc(key, fn(obj[key]), obj);
  };
};
/**
 * Returns a function which accesses a "subset" of an object, identified by a
 * list of keys. For example, `pick('builderAppConfig', 'clientName')` is
 * equivalent to `({ builderAppConfig, clientName }) => ({ builderAppConfig, clientName })`.
 */

export var pick = function pick() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (context) {
    return keys.reduce(function (acc, key) {
      acc[key] = context[key];
      return acc;
    }, {});
  };
}; //
// ADVANCED
//

/**
 * Returns the smallest and largest values of an array (typically of numbers).
 * For example, `getRange([1, 2, 3, 4])` returns `[1, 4]`.
 */

export var getRange = function getRange(context) {
  var isEmpty = function isEmpty(value) {
    return value === null || value === undefined;
  };

  var min;
  var max;
  context.forEach(function (item) {
    if (isEmpty(item)) return;
    if (isEmpty(min) || item < min) min = item;
    if (isEmpty(max) || item > max) max = item;
  });
  return [min, max];
};
/**
 * Converts an array of objects into an array of arrays of key values. For example,
 * if `data` is an array of objects containing "foo" and "bar" properties,
 * `const [foos, bars] = transpose(x => x.foo, x => x.bar)(data)` would be equivalent to
 * `const foos = data.map(datum => datum.foo), const bars = data.map(datum => datum.bar)`.
 * The use of transpose thus prevents iterating over the source data too many times.
 */

export var transpose = function transpose() {
  for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    fns[_key5] = arguments[_key5];
  }

  return function (context) {
    var data = [];

    for (var i = 0; i < fns.length; i++) {
      data.push([]);
    }

    context.forEach(function (item) {
      fns.forEach(function (fn, index) {
        data[index].push(fn(item));
      });
    });
    return data;
  };
};
/**
 * Separates an array into two arrays, based on whether each item passes a condition.
 * Example: `partition(x => x > 4)([2, 4, 6])` evaluates to `[[6], [2, 4]]`.
 */

export var partition = function partition(condition) {
  return function (context) {
    var passers = [];
    var failers = [];
    context.forEach(function (item) {
      if (condition(item)) {
        passers.push(item);
      } else {
        failers.push(item);
      }
    });
    return [passers, failers];
  };
};
/**
 * Groups an array based on the return value of a provided function when run
 * against each item of the array. For example: `groupBy(x => x < 4)([1, 3, 5, 7])`
 * evaluates to `{ 'true': [1, 3, 5], 'false': [7] }`.
 */

export var groupBy = function groupBy(fn) {
  return function (array) {
    var groups = {};
    array.forEach(function (item) {
      var key = fn(item);

      if (groups[key]) {
        groups[key].push(item);
      } else {
        groups[key] = [item];
      }
    });
    return groups;
  };
}; // groupBy_Map -- group values of an array using a function. Returns a Map object.

export var groupBy_Map = function groupBy_Map(keyFn) {
  return function (array) {
    var _map = new Map();

    array.forEach(function (datum) {
      var key = keyFn(datum);

      var collection = _map.get(key);

      if (!collection) {
        _map.set(key, [datum]);
      } else {
        collection.push(datum);
      }
    });
    return _map;
  };
};
export var filterObject = function filterObject(condition) {
  return function (context) {
    var newObject = {};
    Object.entries(context).forEach(function (_ref) {
      var key = _ref[0],
          value = _ref[1];

      if (condition(value, {
        key: key
      })) {
        newObject[key] = value;
      }
    });
    return newObject;
  };
}; // spreadAndFlatten -- Generate an array by combining a two-dimensional array.
//
// Example:
// const parents = [
//   { name: "Eric", children: [
//     { name: "Adam" },
//     { name: "Dave" },
//   ]},
//   { name: "Wendy", children: [
//     { name: "Adam" },
//     { name: "Dave" },
//   ]},
//   { name: "Charlie", children: [
//     { name: "Bob" },
//     { name: "Linda" },
//   ]},
//   { name: "Sarah", children: [
//     { name: "John" },
//     { name: "April" },
//   ]},
// ]
// const children2d = map(getProp('children'), parents)
// const children = spreadAndFlatten(
//   (child1, child2) => child1.name === child2.name,
//   children,
// ) --> [
//   { name: "Adam" },
//   { name: "Dave" },
//   { name: "Bob" },
//   { name: "Linda" },
//   { name: "John" },
//   { name: "April" },
// ]

export var spreadAndFlatten = function spreadAndFlatten(match) {
  return function (array) {
    return array && array.reduce(function (memo, acc) {
      acc.forEach(function (x) {
        if (!memo.find(function (y) {
          return match(x, y);
        })) memo.push(x);
      });
      return memo;
    }, []);
  };
}; //
// BOOLEAN LOGIC
//

export var not = function not(fn) {
  return function (context) {
    return !fn(context);
  };
};
export var both = function both(fn1, fn2) {
  return function (context) {
    return fn1(context) && fn2(context);
  };
};
export var either = function either(fn1, fn2) {
  return function (context) {
    return fn1(context) || fn2(context);
  };
};
export var equals = function equals(a, b) {
  return a === b;
};
export var defaultTo = function defaultTo(defaultValue) {
  return function (input) {
    return input || defaultValue;
  };
};
export var propIsTruthy = function propIsTruthy(key) {
  return function (obj) {
    return !!getProp(key)(obj);
  };
};
/**
 * Evaluates a list of functions against a context, and returns whether every
 * return value was truthy. For example, a function to check whether a number was
 * between 5 and 10 could be written as `const between5And10 = allConditionsPass(x => x >= 5, x => x <= 10)`.
 * Per this example, `between5And10(15)` returns false and `between5And10(8)`
 * returns true.
 */

export var allConditionsPass = function allConditionsPass() {
  for (var _len6 = arguments.length, fns = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    fns[_key6] = arguments[_key6];
  }

  return function (context) {
    return fns.reduce(function (acc, fn) {
      return acc && fn(context);
    }, true);
  };
};
/**
 * Evaluates a list of functions against a context, and returns whether any
 * value returned was truthy.
 */

export var anyConditionsPass = function anyConditionsPass() {
  for (var _len7 = arguments.length, fns = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    fns[_key7] = arguments[_key7];
  }

  return function (context) {
    return fns.reduce(function (acc, fn) {
      return acc || fn(context);
    }, false);
  };
};
/**
 * Get plan name from plan object
 * @param {*} plan - plan object
 */

export var getPlanName = function getPlanName(plan) {
  if (!plan) return '';
  var displayName = plan.displayName,
      name = plan.name;
  return displayName || name || '';
};
/**
 * Checks whether the specified property of a context is equal to a value.
 * `data.find(datum => datum.id === id)` is equivalent to
 * `data.find(propEquals('id', id))`.
 */

export var propEquals = function propEquals(key, value) {
  return function (context) {
    return context[key] === value;
  };
};
/**
 * Similar to propEquals, but checks against an array which corresponds to a path
 * on the context object. `data.find(datum => datum.a.b === id)` is equivalent to
 * `data.find(pathEquals(['a', 'b'], id))`.
 */

export var pathEquals = function pathEquals(keys, value) {
  return function (context) {
    return getPath.apply(void 0, keys)(context) === value;
  };
};
/**
 * Checks whether the specified property of a context is not equal to a value.
 * `data.find(datum => datum.id !== id)` is equivalent to
 * `data.find(propNotEquals('id', id))`.
 */

export var propNotEquals = function propNotEquals(key, value) {
  return function (context) {
    return context[key] !== value;
  };
};
/**
 * Checks whether the specified property of a context is within a range. The range
 * should be an array with two items, a min and a max value.
 *
 * `[{x: 1}, {x: 5}, {x: 10}].filter(propInRange('x', [2, 8]))` returns
 * `[{x: 5}]`.
 */

export var propInRange = function propInRange(key, _ref2) {
  var min = _ref2[0],
      max = _ref2[1];
  return function (context) {
    return context[key] >= min && context[key] <= max;
  };
}; //
// FUNCTIONS FROM ARRAY METHODS
//

export var map = function map(fn) {
  return function (array) {
    return array && array.map(fn);
  };
};
export var filter = function filter(fn) {
  return function (array) {
    return array.filter(fn);
  };
};
export var find = function find(fn) {
  return function (array) {
    return array.find(fn);
  };
};
export var includedBy = function includedBy(array) {
  return function (value) {
    return array && array.includes(value);
  };
};
export var some = function some(fn) {
  return function (array) {
    return array.some(fn);
  };
};
export var reduce = function reduce(fn, initial) {
  return function (array) {
    return array.reduce(fn, initial);
  };
};
export var reject = function reject(fn) {
  return function (array) {
    return array && array.filter(function (x) {
      return !fn(x);
    });
  };
};
export var append = function append(newValue, array) {
  return [].concat(array, [newValue]);
};
export var concat = function concat(array2, array1) {
  return [].concat(array1, array2);
};
export var includesAll = function includesAll(inclusions) {
  return function (array) {
    return inclusions.reduce(function (acc, inclusion) {
      return acc && array.includes(inclusion);
    }, true);
  };
}; // getMap -- convert an array to a Map object (see tests for usage).

export var getMap = function getMap(keyFn, valueFn) {
  return function (array) {
    return new Map(array.map(function (datum) {
      return [keyFn(datum), valueFn(datum)];
    }));
  };
}; //
// MATHS
//

export var round = function round(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      _ref3$up = _ref3.up,
      up = _ref3$up === void 0 ? true : _ref3$up,
      _ref3$toNearest = _ref3.toNearest,
      base = _ref3$toNearest === void 0 ? 1 : _ref3$toNearest;

  return function (value) {
    return value - value % base + up * base;
  };
};
export var getRoundedRange = function getRoundedRange(base) {
  return pipe(getRange, function (_ref4) {
    var min = _ref4[0],
        max = _ref4[1];
    return [round({
      up: false,
      toNearest: base
    })(min), round({
      up: true,
      toNearest: base
    })(max)];
  });
};